import React, { Component } from 'react';
import { CardBody, CardTitle, Form, Row, Col, Label, Button } from 'reactstrap';
import PropTypes from 'prop-types';

import { InputDay, InputTime } from '../components';

class Hours extends Component {
  static propTypes = {
    hours: PropTypes.array.isRequired,
    setHours: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.setTime = this.setTime.bind(this);
    this.addDay = this.addDay.bind(this);
    this.removeDay = this.removeDay.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  setTime = (index, value) => {
    const hours = this.props.hours.map((hour, i) => (i === index ? { ...hour, ...value } : hour));
    this.props.setHours(hours);
  };

  addDay = () => {
    const day = { day: 'placeholder', open: 'placeholder', close: 'placeholder' };
    const hours = [...this.props.hours, day];
    this.props.setHours(hours);
  };

  removeDay = (index) => {
    const hours = this.props.hours.filter((hour, i) => i !== index);
    this.props.setHours(hours);
  };

  renderRow = (hour, index) => (
    <div key={index}>
      <br />
      <Form>
        <Row>
          <Col sm="5">
            <Label>Day</Label>
          </Col>
          <Col sm="3">
            <Label>Open</Label>
          </Col>
          <Col sm="3">
            <Label>Close</Label>
          </Col>
          <Col sm="auto" />
        </Row>
        <Row>
          <Col sm="5">
            <InputDay
              bsSize="lg"
              value={hour.day}
              onChange={e => this.setTime(index, { day: e.target.value })}
            />
          </Col>
          <Col sm="3">
            <InputTime
              bsSize="lg"
              value={hour.open}
              onChange={e => this.setTime(index, { open: e.target.value })}
            />
          </Col>
          <Col sm="3">
            <InputTime
              bsSize="lg"
              value={hour.close}
              onChange={e => this.setTime(index, { close: e.target.value })}
            />
          </Col>
          <Col sm="auto">
            <Button color="danger" size="lg" onClick={() => this.removeDay(index)}>
              X
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );

  render() {
    return (
      <div style={{ backgroundColor: '#fff' }}>
        <CardBody>
          <CardTitle>Hours</CardTitle>
          {this.props.hours.map((day, i) => this.renderRow(day, i))}
          <br />
          <Button className="app-button" onClick={this.addDay}>
            Add Day
          </Button>
        </CardBody>
      </div>
    );
  }
}

export { Hours };



// WEBPACK FOOTER //
// ./src/business/register/components/hours.js